// @ts-nocheck
import React, { useEffect, useState } from "react";
import DashboardLayout from "../../components/layoutContainers/dashboardLayout";
import SoftBox from "../../components/common/softBox";
import { Card, MenuItem } from "@mui/material";
import SoftTypography from "../../components/common/softTypography";
import Table from "../../components/tables/table";
import { useNavigate } from "react-router-dom";
import DashboardNavbar from "../../components/navbars/dashboardNavbar";
import { useAppDispatch, useAppSelector } from "../../Hooks";
import {
  changeCreditLimitStatus,
  getCreditLimitRequestsData,
} from "../../features/creditLimitRequests";
import SoftBadge from "../../components/common/softBadge";
import { toast } from "react-toastify";
import ActionMenu from "../../components/common/custom/action-menu";

const CreditLimitRequests = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  // const handleSnpAdd = () => { }
  const handleStatusChange = (id, status) => {
    dispatch(changeCreditLimitStatus({ id, status })).then((resultAction) => {
      if (changeCreditLimitStatus.rejected.match(resultAction)) {
        console.error(resultAction.payload || resultAction.error);
      } else {
        toast.success("Credit Limit Status Updated Successfully");
      }
    });
  };

  const {
    data: creditData,
    status,
    total,
  } = useAppSelector((state: any) => state.creditLimitRequests);
  const [totalRows, setTotalRows] = useState(0);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  var columns = [
    {
      header: "ID",
      accessorKey: "id",
      id: "id",
      align: "center",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "Name",
      accessorKey: "user_id",
      id: "owner_name",
      align: "left",
      cell: (info: any) => <strong>{info.getValue()?.owner_name || ""}</strong>,
    },
    {
      header: "Reason",
      accessorKey: "increase_limit_reason",
      id: "increase_limit_reason",
      align: "left",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "Percentage",
      accessorKey: "increase_percentage",
      id: "increase_percentage",
      align: "left",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "Monthly Sales Avarage",
      accessorKey: "monthly_sales_avarage",
      id: "monthly_sales_avarage",
      align: "left",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "New Credit Limit",
      accessorKey: "new_credit_limit",
      id: "new_credit_limit",
      align: "left",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "Status",
      accessorKey: "status",
      id: "status",
      align: "left",
      cell: (info: any) => (
        <SoftBadge
          variant="gradient"
          badgeContent={info.getValue()}
          color={
            info.getValue() === "pending"
              ? "info"
              : info.getValue() === "reject"
              ? "error"
              : "success"
          }
          size="xs"
          container
        />
      ),
    },
    {
      header: "Actions",
      id: "actions",
      align: "center",
      cell: (info: any) => {
        const id = info.row.original._id;
        // const snp_no = info.row.original.sap_no;
        const status = info.row.original.status;

        return (
          <div>
            <ActionMenu sx={{ width: "50px" }}>
            {/* {
              <IconButton onClick={() => handleSnpAdd(id)}>
                <IoMdAdd />
              </IconButton>
            } */}

            {!(status === "approve") && (
              <MenuItem onClick={() => handleStatusChange(id, "approve")}>
                Approve
              </MenuItem>
            )}

            {(status === "pending" || status === "approve") && (
              <MenuItem onClick={() => handleStatusChange(id, "reject")}>
                Reject
              </MenuItem>
            )}
            <MenuItem onClick={() => navigate(`/credit-limit/view/${id}`)}>
              View
            </MenuItem>
            </ActionMenu>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    dispatch(getCreditLimitRequestsData({ page: pageIndex, limit: pageSize }));
  }, [dispatch, pageIndex, pageSize]);

  useEffect(() => {
    // // // console.log("DJ::", { creditData });

    if (status && creditData && creditData.length) {
      setData(creditData);
      setTotalRows(total || 0);
    }
  }, [status, creditData, total]);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <Card>
        <SoftBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          px={3}
          pt={3}
          pb={2}
        >
          <SoftTypography variant="h4" fontWeight="bold" textAlign="left">
            Credit Limit Requests
          </SoftTypography>
        </SoftBox>
        <Table
          columns={columns}
          data={data}
          pageIndex={pageIndex}
          pageSize={pageSize}
          totalRows={totalRows}
          onPageChange={(newPageIndex) => setPageIndex(newPageIndex)}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        />
      </Card>
    </DashboardLayout>
  );
};

export default CreditLimitRequests;
